import { axios } from '@Root/API'

export const remove = fundingAndMonitoringId => {
	return axios.delete(`delete/funding-and-monitoring/student-course-session/${fundingAndMonitoringId}`)
}
